import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { BorderedCard } from '@css/common.elements'
import {
  tableGray,
  darkBlue,
  backgroundGray,
  MQ,
} from '@css/constants'

export const FaqSectionWrapper = styled('div')(css`
  background: ${backgroundGray};
  padding: 60px 0;
`)

export const InnerContent = styled('div')(css`
  margin: 0 auto;
  width: 90%;
  max-width: 1000px;
`)

export const Title = styled('div')(css`
  ${FontNormal(600)};
  font-size: 32px;
  text-align: center;
  margin-bottom: 30px;
`)

export const FaqList = styled('ul')(css`
  list-style: none;
  max-width: 602px;
  margin: 0 auto;
`)

export const FaqListItem = styled(BorderedCard)(css`
  padding: 19px 32px;
  margin-bottom: 8px;
  border-color: ${tableGray};

  ${MQ.SMALL_SCREENS} {
    padding: 19px 24px;
  }
`)

export const FaqTitle = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  cursor: pointer;
`)

export const CollapseBtnWrapper = styled('div')(css`
  display: flex;
  justify-content: center;
`)

export const collapseBtnStyles = css`
  display: flex;
  align-items: center;

  & > svg {
    width: 16px;
    height: 16px;
  }
`
